export enum BOOK_INVITE_CLAIM_PREVIEW_STATUS {
    unassigned = 'unassigned',
    pending = 'pending',
    claimed = 'claimed',
    revoked = 'revoked',
    expired = 'expired',
    notFound = 'not-found',
}
